import React, { useEffect, useState } from "react";
import { FichaContribPrevidencialEntidade, PlanoVinculadoEntidade } from "@entidades";
import { FichaContribPrevidencialService } from "@services";
import { LoadingComponent } from "@components";
import { Alert, Box, StaticField } from "@intech/web-ui";
import { DateFix } from "@helpers";

interface IProps {
  plano: PlanoVinculadoEntidade;
}

export const UltimaContribuicao: React.FC<IProps> = ({ plano }) => {
  const [UltimaContrib, setUltimaContrib] = useState<FichaContribPrevidencialEntidade[]>([]);
  const [Referencia, setReferencia] = useState<string>("");

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const ultimaContrib = await FichaContribPrevidencialService.BuscarUltimaContribuicao(plano.SQ_PLANO_PREVIDENCIAL);
        setUltimaContrib(ultimaContrib);
        if (ultimaContrib.length > 0)
          setReferencia(DateFix(ultimaContrib[0].DT_REFERENCIA, "MM/yyyy"));
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [plano]);

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && (!UltimaContrib || UltimaContrib.length === 0) && <Alert type={"info"}>{"Nehuma contribuição disponível no momento."}</Alert>}

      {!Loading && !Erro && UltimaContrib && UltimaContrib.length > 0 &&
        <Box title={<b>{"Última Contribuição"}</b>} badgeText={`Referéncia: ${Referencia}`}>
          <table className={"table table-striped table-sm"}>
            <thead>
              <tr>
                <th>{"Contribuição"}</th>
                <th className={"text-right"}>{"Valor (R$)"}</th>
                <th className={"text-right"}>{"Valor da Cota"}</th>
                <th className={"text-right"}>{"Cotas Adquiridas"}</th>
              </tr>
            </thead>
            <tbody>
              {UltimaContrib.map((contrib: FichaContribPrevidencialEntidade, index: number) => {
                return (
                  <tr key={index}>
                    <td>{contrib.DS_TIPO_COBRANCA}</td>
                    <td className={"text-right"}>
                      <StaticField value={contrib.VL_CONTRIBUICAO} type={"money"} />
                    </td>
                    <td className={"text-right"}>
                      <StaticField value={contrib.VL_COTA} />
                    </td>
                    <td className={"text-right"}>
                      <StaticField value={contrib.QT_COTA_CONTRIBUICAO} />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </Box>}
    </>
  );
}